import { RatingForm } from './RatingForm';

const GenerateRiskRating = ({ control, watchAllFields, viewMode }: any) => {
  return <RatingForm control={control} watchAllFields={watchAllFields} viewMode={viewMode} />;
};

export default GenerateRiskRating;
